<script setup>
import { onMounted, ref } from 'vue';
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import PricePerTimeOutput from '../club/sales-list/PricePerTimeOutput.vue';

defineProps({
    offeringItems: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['update:selectedSalesListOfferingItems']);
const selectedSalesListOfferingItems = ref([]);
const quantities = ref({});

onMounted(() => {
    emit('update:selectedSalesListOfferingItems', selectedSalesListOfferingItems.value);
});

function addOrRemove(itemId) {
    const quantity = quantities.value[itemId] || 1;
    const existingIndex = selectedSalesListOfferingItems.value.findIndex((item) => item.id === itemId);
    if (existingIndex === -1) {
        const offeringItem = { id: itemId, numerator: quantity, denominator: 1 };
        selectedSalesListOfferingItems.value.push(offeringItem);
    } else {
        selectedSalesListOfferingItems.value.splice(existingIndex, 1);
    }
    emit('update:selectedSalesListOfferingItems', selectedSalesListOfferingItems.value);
}

function updateQuantity(itemId, quantity) {
    quantities.value[itemId] = quantity;
    const existingIndex = selectedSalesListOfferingItems.value.findIndex((item) => item.id === itemId);
    if (existingIndex !== -1) {
        selectedSalesListOfferingItems.value[existingIndex].numerator = quantity;
        emit('update:selectedSalesListOfferingItems', selectedSalesListOfferingItems.value);
    }
}

function isSelected(itemId) {
    return selectedSalesListOfferingItems.value.some((item) => item.id === itemId);
}
</script>

<template>
    <div class="mb1">
        {{ $t('Hier kannst du der Buchung zusätzliche Angebotsartikel hinzufügen') }}
        <table
            vue:is="kgr-table"
            class="kgr-table kgr-table--striped kgr-table--block"
            :is-data-table="false"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        sortable
                    >
                        {{ $t('Name') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Preise') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--center"
                    >
                        {{ $t('Anzahl') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    ></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in offeringItems"
                    :key="item.id"
                    class="kgr-table_row"
                >
                    <td class="kgr-table__cell">
                        {{ item.clubFeeName }}
                    </td>
                    <td class="kgr-table__cell">
                        <price-per-time-output
                            :price="item.pricePerTime"
                            with-vat
                        />
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--center">
                        <input
                            type="number"
                            min="1"
                            step="1"
                            :value="quantities[item.id] || 1"
                            @input="updateQuantity(item.id, parseInt($event.target.value) || 1)"
                            :disabled="!isSelected(item.id)"
                            class="quantity-input"
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <checkbox
                            :checked="isSelected(item.id)"
                            @change="addOrRemove(item.id)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped lang="scss">
.quantity-input {
    width: 60px;
    padding: 4px 8px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
        opacity: 0.6;
    }
}
</style>
